export default __webpack_public_path__ + "static/rovo-multiple-indicators-light-6b0fc3f3f1d755147bc0845bcf364f92.png";